<template lang="pug">
div(
  v-show='searchQuery.length >= 3'
  id='searchResults'
  data-testid='searchResults'
  class='absolute max-h-[350px] overflow-y-scroll bg-white top-full text-left text-black inset-x-0 z-10'
)
  AlgoliaWrapper(:search-context='$algolia.searchContexts.searchInstallationGuides' index='products')
    AlgoliaResults(v-if='hasResults')
      div(class='p-3 mb-2 border-b')
        p(class='font-bold mb-4') Products
        AlgoliaResults
          template(#result='{ result }')
            UniversalLink(:key='result.objectID' :link='formatUrl(result.productLineSlug)' class='block text-black pb-4')
              div(class='flex space-x-4')
                div(class='flex-none')
                  template(v-if='result.image')
                    img(
                      :src='getImageUrl(result.image.key, result.image.filename, 101, 76)'
                      :alt='result.productName'
                      width='101'
                      height='76'
                    )

                div(class='flex-1')
                  InlineHtml(:text='result.productLineName')

  AlgoliaWrapper(:search-context='$algolia.searchContexts.searchInstallationGuides' index='sku')
    AlgoliaResults(v-if='hasResults')
      div(class='p-3 mt-2')
        p(class='font-bold mb-4') Part Numbers
        AlgoliaResults
          template(#result='{ result }')
            UniversalLink(
              :key='result.objectID'
              :link='formatUrl(result.productLineSlug, result.skuSlug)'
              class='block text-black pb-4'
            )
              div(class='flex space-x-4')
                div(class='flex-none')
                  template(v-if='result.image')
                    img(
                      :src='getImageUrl(result.image.key, result.image.filename, 101, 76)'
                      :alt='result.productName'
                      width='101'
                      height='76'
                    )

                div(class='flex-1')
                  InlineHtml(:text='result.productLineName')
                  div(class='font-bold') SKU: {{ result.sku }}

  div(v-if='!hasResults' class='result-group no-results')
    | No results found
</template>

<script>
export default defineNuxtComponent({
  name: 'InstallationInstructionsResults',
  setup() {
    const { getImageUrl } = useUrls()
    return {
      getImageUrl,
    }
  },
  props: {
    searchQuery: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasResults() {
      return this.$algolia.searchContexts.searchInstallationGuides.indexes.every(
        (index) => index.state.value.resultCount !== null && index.state.value.resultCount !== 0
      )
    },
  },
  watch: {
    searchQuery(newVal) {
      // Must type a min of 3 characters before running the search
      if (newVal.length < 3) return
      this.$algolia.searchContexts.searchInstallationGuides.setQuery(newVal).search()
    },
  },
  methods: {
    formatUrl(productLineSlug, skuSlug = '') {
      let url = `/p/${productLineSlug}/${skuSlug}`
      url += this.$device.value.isMobile ? '?mod=install' : '#scrollTarget-install'

      return url
    },
  },
})
</script>
